import { render } from "./SynopsisCard.vue?vue&type=template&id=faf2e30c&ts=true"
import script from "./SynopsisCard.vue?vue&type=script&lang=ts"
export * from "./SynopsisCard.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__